import { useParams } from "react-router-dom";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import ChatbotCreateV2 from "@/pages/CreateCharacter/v2/CreateCharacter";
import useAuth from "@/services/useAuth";

import ChatbotEditV2 from "./ChatbotEdit";

export default function Chatbot() {
  const { characterId } = useParams();
  const { isAuthenticated } = useAuth();

  const renderChatbotContent = () => {
    if (characterId) {
      return <ChatbotEditV2 characterId={characterId} />;
    }
    if (isAuthenticated) {
      return <ChatbotCreateV2 />;
    }
    return (
      <>
        <PageStaticMetaTags pageId="createCharacter" data-testid="ChatbotAnonymous-PageStaticMetaTags" />
        <AnonymousMarketing datakey="chatbot" />
      </>
    );
  };

  return renderChatbotContent();
}
